const flattenMenuItems = (items) =>
    items.flatMap((item) => [
        ...(item.route ? [{ route: item.route, label: item.label }] : []),
        ...(item.children ? flattenMenuItems(item.children) : []),
    ])

const isActiveRoute = (pathname, route) =>
    route === "/"
        ? pathname === route
        : pathname === route || pathname.startsWith(`${route}/`)

export const resolveActiveMenuLabel = (menuItems, pathname) => {
    const routeItem = flattenMenuItems(menuItems)
        .filter(({ route }) => route.startsWith("/"))
        .sort((first, second) => second.route.length - first.route.length)
        .find(({ route }) => isActiveRoute(pathname, route))

    return routeItem?.label
}
